import auth from "./adminAuth";
import schoolAuth from "./schoolAuth";
import userAuth from "./userAuth";
import userAttach from "./api-userAttach";
import school from "./school";
import notification from "./notification";
import media from "./media";
import carousel from "./carousel";

// Admin
import orgAuth from "./adminApis/api-orgAuth";
import layout from "./adminApis/api-layout";
import org from "./adminApis/api-org";
import user from "./adminApis/api-user";
import trains from "./adminApis/train/trainApi";
import course from "./adminApis/train/courseApi";
import task from "./adminApis/train/taskApi";
import log from "./adminApis/train/logApi";
import template from "./adminApis/train/templateApi";
import adminNotification from "./adminApis/notification";
import adminMedia from "./adminApis/mediasApi";

import expert from "./adminApis/expertsApis";
import adminActivity from "./adminApis/compete/activitiesApis";
import adminProject from "./adminApis/compete/projectsApis";
import adminEntry from "./adminApis/compete/entriesApis";
import meetingAgenda from "./adminApis/meeting/agendasApis";
import meetingAppointment from "./adminApis/meeting/appointmentsApis";
import meetingReserve from "./adminApis/meeting/reservesApis";
import meetingRoom from "./adminApis/meeting/roomsApis";
import meetingBooking from "./adminApis/meeting/bookingApis";
import meetingHome from "./adminApis/meeting/homeApis";

import material from "./adminApis/resources/api-video";
// research
import adminResearchActivity from "./adminApis/research/api-activity";
import catalog from "./adminApis/research/api-catalog";
import receiptLog from "./adminApis/research/api-log";
import adminMessage from "./adminApis/research/api-message";
import adminResearchProject from "./adminApis/research/api-project";
import adminResearchReceipt from "./adminApis/research/api-receipt";
import stage from "./adminApis/research/api-stage";
// train
import adminTrainActivity from "./adminApis/train/api-activity";
import adminTrainEntry from "./adminApis/train/api-entry";
import adminTrainCourse from "./adminApis/train/api-course";
import adminTrainAttendance from "./adminApis/train/api-attendance";
import adminTrainHomework from "./adminApis/train/api-homework";
// School
import schoolCompeteActivity from "./schoolApis/compete/activitiesApis";
import schoolCompeteProject from "./schoolApis/compete/projectsApis";
import schoolCompeteEntry from "./schoolApis/compete/entriesApis";
import schoolTrainEntry from "./schoolApis/train/entriesApis";
import schoolResearchProject from "./schoolApis/research/api-project";
// expert
import expertInfo from "./expertApis/expertApis";
import expertCompeteProject from "./expertApis/compete/projectsApis";
import expertCompeteMarks from "./expertApis/compete/marksApis";
import expertCompeteMarkDetail from "./expertApis/compete/markDetailApis";
import expertStage from "./expertApis/api-stage";
import expertActivity from "./expertApis/train/api-activity";
import expertEntry from "./expertApis/train/api-entry";
import expertHomework from "./expertApis/train/api-homework";
import expertLog from "./expertApis/train/api-log";
import expertTask from "./expertApis/train/api-task";
// user
import userNotifications from "./userApis/train/userNotificationTrainApi";
import userCenter from "./userApis/train/userCenterApis";
import userTrain from "./userApis/train/trainApi";
import userCourse from "./userApis/train/userCourseApi";
import userLog from "./userApis/train/userLogApi";
import userWork from "./userApis/train/userWorkApi";
import userCompete from "./userApis/compete/competeApis";

import userAppointment from "./userApis/meeting/appointmentsApis";
import userReserve from "./userApis/meeting/reservesApis";
import userBooking from "./userApis/meeting/bookingApis";

import video from "./userApis/resources/video";

import userResearchActivity from "./userApis/research/api-activity";
import userResearchFund from "./userApis/research/api-fund";
import userResearchMessage from "./userApis/research/api-message";
import userResearchProject from "./userApis/research/api-project";
import userReceipt from "./userApis/research/api-receipt";
import adminStatOrgs from "@/apiSet/adminApis/stat/api-orgs";

export default {
  adminStatOrgs,
  auth,
  userAuth,
  schoolAuth,
  userAttach,
  notification,
  media,
  carousel,
  // 待分类
  trains,
  course,
  task,
  log,
  template,
  // admin
  orgAuth,
  layout,
  org,
  user,
  adminNotification,
  adminMedia,
  adminActivity,
  adminProject,
  adminEntry,
  meetingAgenda,
  meetingAppointment,
  meetingReserve,
  meetingRoom,
  meetingBooking,
  meetingHome,
  material,
  adminResearchActivity,
  adminResearchProject,
  adminResearchReceipt,
  stage,
  adminTrainActivity,
  adminTrainEntry,
  adminTrainCourse,
  adminTrainAttendance,
  adminTrainHomework,
  catalog,
  receiptLog,
  adminMessage,
  // school
  school,
  schoolCompeteActivity,
  schoolCompeteProject,
  schoolCompeteEntry,
  schoolTrainEntry,
  schoolResearchProject,
  // expert
  expert,
  expertInfo,
  expertCompeteProject,
  expertCompeteMarks,
  expertCompeteMarkDetail,
  expertStage,
  expertActivity,
  expertEntry,
  expertHomework,
  expertLog,
  expertTask,
  // user
  userNotifications,
  userCenter,
  userTrain,
  userCourse,
  userLog,
  userWork,
  userAppointment,
  userReserve,
  userBooking,
  userCompete,
  video,
  userResearchActivity,
  userResearchFund,
  userResearchMessage,
  userResearchProject,
  userReceipt,
};



// WEBPACK FOOTER //
// ./src/apiSet/index.js